import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
  tag: {},
}

// getters
const getters = {
  tag: (state) => {
    return state.tag;
  },
}

// mutations
const mutations = {
  SET_META_TAG(state, tag) {
    state.tag = tag;
  },
}

// actions
const actions = {
  getTag({commit}, tag) {
    return axios.get('/admin/metatag/' + tag)
    .then((response) => {
      commit('SET_META_TAG', response.data.tag);
    });
  },
  updateMeta ({}, metaData) {

    let formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('category_title', metaData.category_title ?  metaData.category_title  :"");
    formData.append('category_meta_title', metaData.category_meta_title ? metaData.category_meta_title : "");
    formData.append('category_meta_description', metaData.category_meta_description ?  metaData.category_meta_description : "");
    formData.append('category_meta_keyword', metaData.category_meta_keyword ?  metaData.category_meta_keyword : "");
    formData.append('category_description', metaData.category_description ? metaData.category_description : "");
    formData.append('faq_title', metaData.faq_title ? metaData.faq_title : "");
    formData.append('faq_meta_title', metaData.faq_meta_title ? metaData.faq_meta_title : "");
    formData.append('faq_meta_description', metaData.faq_meta_description ?  metaData.faq_meta_description : "");
    formData.append('faq_meta_keyword', metaData.faq_meta_keyword ?  metaData.faq_meta_keyword : "");
    formData.append('faq_description', metaData.faq_description ? metaData.faq_description : "");

    return axios.post('/admin/metatag/' + metaData.id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      return response;
    })

  }


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
